import React, { useEffect } from 'react';
import './psfomdps.css';
import { psfomdps } from '../../json/psfomdps';

const Psfomdps = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Programa Fomento al Desarrollo de la Participación Social</h3>
          <hr className='hr-gob' />
        </div>
      </div>
      
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
             
              <div style={{ textAlign: 'left' }}>
                <h5 style={{ fontWeight: 'bold' }}>Descripción del Programa</h5>
                <p>
              
                </p>
                <h6 className='description' style={{ marginTop: '20px' }}>
                El Programa de Fomento al Desarrollo de la Participación Social fortalece y vincula entre sí y con los diversos órganos de gobierno a los Actores Sociales para que a través del fomento a sus actividades promuevan la cohesión y capital social, así como el desarrollo humano y social de grupos, comunidades o regiones que viven en situación de vulnerabilidad o exclusión. Asimismo, contribuye a la conformación, organización y funcionamiento de mecanismos de participación ciudadana con enfoque de derechos y género, en el marco de los programas sociales del Gobierno del Estado de Hidalgo, que promuevan procesos participativos de incidencia en políticas públicas y fortalezca la gobernabilidad democrática, a través del diálogo y consulta con actores gubernamentales y sociales, así como acciones de capacitación para los integrantes de los mecanismos.<br /><br />
                El Programa está diseñado para propiciar y fortalecer la participación de los Actores Sociales en las políticas de desarrollo social impulsadas por el Gobierno del Estado de Hidalgo y coadyuvar en la promoción de la transparencia y el combate a la corrupción en la gestión pública.
                </h6><br />
                <h5 style={{ fontWeight: 'bold' }}>Objetivo del Programa</h5>
                <p>
                Impulsar la participación social y democrática para fomentar la construcción del tejido y la cohesión social, a través de mecanismos de promoción y vinculación que fortalezcan el desarrollo local y estatal.
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Población Objetivo</h5>
                <p>
                Organizaciones de la Sociedad Civil del estado de Hidalgo formalmente constituidas.
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Cobertura</h5>
                <p>
                El Programa tendrá cobertura en los 84 municipios del estado de Hidalgo, y los apoyos se otorgarán conforme a la capacidad que permita la infraestructura y disponibilidad presupuestal.
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Vigencia</h5>
                <p>
                Anual
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Áreas de atención</h5>
                <p>
                  
                  <ul>
                  <li>Secretaría de Bienestar en Inclusión Social<br />                    
                  </li>
                  <li>Subsecretaría de Participación Social y Fomento Artesanal<br />
                  </li>
                  </ul></p>
                <h5 style={{ fontWeight: 'bold' }}>Personas Responsables del Programa</h5>
                <p>
                  
                  <ul>
                  <li>Lic. Claudia Aurora Márquez Camacho<br />                    
                  </li>
                  </ul></p>
                <h5 style={{ fontWeight: 'bold' }}>Teléfono de Contacto</h5>
                <p>
                (771) 1 07 39 52<br />
                (771) 1 07 39 58
                </p>
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2023/ROPS_Participacion_2023.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Reglas de Operación</a></strong></h5>
                <p>
                </p>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                //href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/folios/2023/ResultadosPFDPS.pdf'
                //target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                ></a></strong></h5>
                <p>
                </p>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                //href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/folios/2023/ReasignacionPFDPS_2023.pdf'
                //target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                ></a></strong></h5>
                <p>
                </p>
                
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2023/3erTRIM2023FomDesPS.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Padrón de Beneficiarios</a></strong></h5>
                <p>
                </p>
                
              </div>
            </div>
            
          </div>
        </div>
      </div>    
    </div>
  );
};

export default Psfomdps;